import { render, staticRenderFns } from "./NuevoTipoTurno.vue?vue&type=template&id=fe46f53e&scoped=true"
import script from "./NuevoTipoTurno.vue?vue&type=script&lang=js"
export * from "./NuevoTipoTurno.vue?vue&type=script&lang=js"
import style0 from "./NuevoTipoTurno.vue?vue&type=style&index=0&id=fe46f53e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe46f53e",
  null
  
)

export default component.exports